import { render, staticRenderFns } from "./BBGroups.vue?vue&type=template&id=6f515535&scoped=true&lang=pug"
import script from "./BBGroups.vue?vue&type=script&lang=js"
export * from "./BBGroups.vue?vue&type=script&lang=js"
import style0 from "./BBGroups.vue?vue&type=style&index=0&id=6f515535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f515535",
  null
  
)

export default component.exports